import { render, staticRenderFns } from "./ct-switch.vue?vue&type=template&id=6f606263&scoped=true"
import script from "./ct-switch.vue?vue&type=script&lang=js"
export * from "./ct-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f606263",
  null
  
)

export default component.exports